module.exports = __webpack_public_path__ + "images/emails/bg-page-t-86ff80b7.png";